import {Blockquote, Button, Project, List} from "arwes";
import {Trans} from "react-i18next";
import {useState} from "react";

const ReadMore = ({children}) => {

    const text = children;
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    }
    return(
        <div >
                <Trans>
                {
                     isReadMore  ?
                        text.slice(0, 150)
                        :
                       text
                }</Trans>

                <span onClick={toggleReadMore} className="read-or-hide">

                    {
                         isReadMore   ?
                            <Button align="center" animate> <Trans>Read More </Trans></Button> :
                            <Button align="center" animate> <Trans>Show Less </Trans></Button>
                    }

                </span>

        </div>
    )
}
const ArtificialIntelligence = () => {



    return(
            <div >
                <div>
                    <Blockquote > Artificial intelligence</Blockquote>
                </div>
                <Project
                    className="col-xs-12 col-md-12 col-lg-12"
                    animate
                    header=""
                    style={{ padding: 20 }}
                >
                    { anim => (

                            <ReadMore>

                                      But first of all Let's fix the questions about what Artificial Intelligence. Are Artificial Intelligence going the take control of the world? What are some of the biggest threats about artificial intelligence?
                                      Threats about Artificial Intelligence are many but we are going to group them according to many criteria. But we are going to group them in 3 parts: the first levels, seconds level and third levels


                            </ReadMore>

                    )}
                </Project>


                <Project
                    className="col-xs-12 col-md-12 col-lg-12"
                    animate
                    header=""
                    style={{ padding: 20 }}
                >
                    { anim => (
                        <p>
                            <Trans>
                                Maybe if you would like to know more about AI and studying engineering maybe we have recommendations for you.
                            </Trans>
                            <br/> <br/>
                            <Button align="center" animate><Trans>Read More</Trans></Button>
                        </p>
                    )}
                </Project>

                <Project
                    className="col-xs-12 col-md-12 col-lg-12"
                    animate
                    header=""
                    style={{ padding: 20 }}
                >
                    { anim => (
                        <p>
                            <Trans>
                              
                            </Trans>
                            <br/> <br/>
                            <Button align="center" animate><Trans>Read More</Trans></Button>
                        </p>
                    )}
                </Project>

            </div>
        )
}

export default ArtificialIntelligence
